import React from "react";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

import AclTable from "../../../components/AclTable";
import UserCol from "../../../components/columns/UserCol";

import Card from "@mui/material/Card";
import MDBox from "materialDashboard/components/MDBox";


const CardPermissions = () => {
    const {t} = useTranslation(['stations']);
    const {stationId} = useParams();
    const resourceId = parseInt(stationId);

    return <Card>
        <MDBox py={2} px={2}>
            <AclTable title={t('station.cardPermissions.title')}
                      principalType="user"
                      resourcesType="station"
                      resourceId={resourceId}
                      permissions={["mod1:write", "mod23:write"]}
                      entityHeader={t('station.cardPermissions.user')}
                      renderEntityCol={(user) => <UserCol user={user}/>}
                      multipleCheck
                      entitySortFieldName="surname"
                      dataTableProps={{canSearch: true, showTotalEntries: true, entriesPerPage: true}}
            />
        </MDBox>
    </Card>
}

export default CardPermissions;